var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat_gradient",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "flat gradient",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3.002,
    x2: 61.037,
    y1: 31.984,
    y2: 31.984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#096fe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15843,
    stopColor: "#167ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ec3f6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.35999 58.82996c-4.10999 0-8.04999-.91998-11.71997-2.72998-.95001-.46997-1.63-1.38-1.79992-2.4199-.52134-2.49901 2.35412-4.68433 4.60989-3.46021 7.85586 4.03808 18.04311 2.04973 23.86975-4.61982 10.98141-11.97159 3.49257-32.03156-12.65977-33.78004-5.78998-.65002-11.35999 1.12-15.67999 4.98999-4.06 3.63-6.48999 8.76001-6.76001 14.19 0 0 4.97003 0 4.97001.00002.79253-.03376 1.29947.98767.80001 1.59995l-7.64996 10.08002c-.18005.25-.48004.39996-.79004.39996-.31314.0032-.60822-.14719-.79999-.39996l-7.54999-10.08002c-.23004-.29999-.26001-.70996-.09003-1.04999.17004-.34003.51001-.54999.89001-.54999 0 0 3.72998 0 3.7302.00025.2735-14.5999 13.67249-27.03368 28.31979-25.78028 13.41669.84543 24.07899 11.6563 24.90002 25.07001 1.27432 14.98629-11.56072 28.86333-26.59003 28.53998zm-.00452-43.17371c-1.10449 0-2 .89551-2 2v14.34375c0 .52783.20898 1.03467.58105 1.40918 0 0 5.41211 5.45117 5.41211 5.45117.7774.78384 2.04537.78817 2.82813.01025.78418-.77832.78809-2.04492.00977-2.82861l-4.83105-4.86621v-13.51953c0-1.10449-.89551-2-2-2z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6ab9fe7ebdab7853bb2325f4bcccf875.svg";
export { ForwardRef as ReactComponent };